import { render, staticRenderFns } from "./UpdateBillingHandler.vue?vue&type=template&id=16ea3ef6&"
import script from "./UpdateBillingHandler.vue?vue&type=script&lang=js&"
export * from "./UpdateBillingHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports